define([
    "csi/def/ActionFactory",
    "csi/xml",
    "./FreezeBase"
], function(ActionFactory,xml,FreezeBase) {

    return ActionFactory.declare("Unfreeze", FreezeBase, {
        constructor: function(obj) {
            this.m_tag = this.m_tag || "Unfreeze";
        },

        checkNodeAccess: function(node) {
            return this.inherited(arguments) && xml.nodeIsFrozen(node);
        }
    });
});